module.exports = __webpack_public_path__ + "img/d1.28bbe7fa.png";